import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function App({ labels, dataset }: any) {
  const data = {
    labels: labels,
    datasets: [
      {
        data: dataset,
        backgroundColor: [
          "#F5AE45",
          "#00ADC6",
          "#231E28",
          "#FF8372",
          "#9ECC7A",
          "#FD5F07",
          "#6BBFBC",
        ],
        borderColor: [
          "#F5AE45",
          "#00ADC6",
          "#231E28",
          "#FF8372",
          "#9ECC7A",
          "#FD5F07",
          "#6BBFBC",
        ],
        borderWidth: 1,
      },
    ],
  };
  return <Doughnut data={data} />;
}
